import { useEffect, useRef, useState } from "react";
import { DataGrid, Column } from "devextreme-react/data-grid";
import { createSitesClientApi } from "../../../api-client-nswag/taxportal-client-runtime";
import { Modal } from "../../../cui/components/Modal/Modal";


type DatagridRefType = DataGrid;
const initialStateData = { pending: true, changes: [] };

export const ModalProcessDetail = ({
  siteId,
  isDisplayModal,
  handleClose
}: any) => {
  const detailsGridRef = useRef<DatagridRefType>(null);
  const [changesDetailData, setChangesDetailData] = useState<any>(initialStateData);
  const styles = { position: "right", margin: "0", height: "100%", maxHeight: "100%" };

  const fetchData = async () => {
    try {
      if (!siteId) {
        setChangesDetailData({ pending: false, changes: [] });
        return;
      }
      setChangesDetailData(initialStateData);
      const result = await createSitesClientApi.taxportal_GetSubProcessExecutionDetails(String(siteId));
      setChangesDetailData({ pending: false, changes: result?.data });
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, [siteId]);

  return (
    <Modal
      title="Review changes"
      maxWidth="sm"
      btnCloseText="Close"
      btnCloseTop={true}
      isDisplayModal={isDisplayModal}
      handleClose={handleClose}
      styles={styles}
    >
      <div>
        <DataGrid
          id="grid-modal-changes"
          ref={detailsGridRef}
          keyExpr="id"
          allowColumnResizing
          dataSource={changesDetailData.changes}
          noDataText={changesDetailData.pending ? "Loading..." : "No data"}
          showBorders
          wordWrapEnabled
        >
          <Column dataField="description" caption="Description" />
          <Column dataField="status" caption="Status" />
          <Column dataField="statusMessage" caption="Status Message"/>
        </DataGrid>
      </div>
    </Modal>
  );
};